<template>
  <div v-if="isOpen">
    <div class="bg-white rounded-lg p-4 border-gray-200 text-left text-gray-800 mb-8">
      <p class="font-bold text-lg mb-4">Período a filtrar</p>

      <div class="flex flex-col mb-5">
        <DatePicker
          v-model="startDate"
          :masks="{ modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' }"
          is-required
        >
          <template #default="{ inputValue, inputEvents }">
            <v-text-field
              label="Data inicial"
              :model-value="inputValue"
              v-on="inputEvents"
              class="w-full"
              color="primary20"
              variant="outlined"
              density="comfortable"
              :append-inner-icon="mdiCalendarBlankOutline"
            />
          </template>
        </DatePicker>

        <DatePicker
          v-model="endDate"
          locale="pt-BR"
          :masks="{ modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' }"
        >
          <template #default="{ inputValue, inputEvents }">
            <v-text-field
              label="Data final"
              :model-value="inputValue"
              v-on="inputEvents"
              class="w-full"
              color="primary20"
              variant="outlined"
              density="comfortable"
              :append-inner-icon="mdiCalendarBlankOutline"
            />
          </template>
        </DatePicker>
      </div>

      <div class="flex justify-between gap-3">
        <OutlineButton
          text="Cancelar"
          color="primary30"
          height="40px"
          width="120px"
          @click="$emit('close')"
        />

        <FilledButton
          text="Aplicar filtros"
          color="primary30"
          height="40px"
          width="160px"
          class="bg-primary30"
          @click="applyFilters"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import { mdiCalendarBlankOutline } from '@mdi/js'

defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits(['close', 'apply-filters'])

const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)

const applyFilters = () => {
  emit('apply-filters', {
    startDate: startDate.value,
    endDate: endDate.value
  })
}
</script>

<style>
.v-text-field .v-input__control {
  width: 100%;
}
</style>
